import { useVehiclePhotosByKind } from 'Components/Gallery';

import { DamageCard } from '../ConditionAndDamageSection/Components/DamageCard';

import styles from './MobilizeTyreDamageSection.module.scss';

export const MobilizeTyreDamageSection: React.FC = () => {
	const images = useVehiclePhotosByKind(['damage_tyre']);

	if (images.length === 0) {
		return <p>No tyre damage reported</p>;
	}

	return (
		<div className={styles.grid} data-testid="mobilize-tyre-damage-section">
			{images.map((image) => (
				<DamageCard key={image.id} image={image} showOverlay={false} />
			))}
		</div>
	);
};
